export default __webpack_public_path__ + "static/media/resume.35ac2018.pdf";